import { Component, OnInit } from "@angular/core";
import { Modals } from "@capacitor/core";
import { ModalController } from "@ionic/angular";
import moment from "moment";
import { Consultor } from "../../models/consultores.model";
import { FiltrosGuias } from "../../models/guias.model";
import { ConsultoresService } from "../../services/consultores.service";

@Component({
  selector: "app-consultores-relatorio-filtro",
  templateUrl: "./consultores-relatorio-filtro.page.html",
  styleUrls: ["./consultores-relatorio-filtro.page.scss"],
})
export class ConsultoresRelatorioFiltroPage implements OnInit {
  filtros: FiltrosGuias = new FiltrosGuias();
  public empresas: Consultor[];

  AguardandoAgendamento = "Aguardando Agendamento";
  AguardandoConfirmacao = "Aguardando Confirmação";
  Agendado = "Agendado";
  Pago = "Pago";
  Atendida = "Atendida";

  constructor(
    private service: ConsultoresService,
    public modalCtrl: ModalController
  ) {}

  ngOnInit() {
    this.carregarConsultores();
  }

  carregarConsultores() {
    this.service.getAll().subscribe(
      (empresas) => {
        this.empresas = empresas;
      },
      async (error) => {
        await Modals.alert({
          title: "Erro",
          message: error,
        });
      }
    );
  }

  filtrar() {
    this.filtros.startDate = moment(this.filtros.startDate).format(
      "DD/MM/YYYY"
    );
    this.filtros.endDate = moment(this.filtros.endDate).format("DD/MM/YYYY");
    this.modalCtrl.dismiss(this.filtros);
  }
}
